const markdownPickerTypes: FilePickerAcceptType[] = [
  {
    description: "Markdown",
    accept: { "text/markdown": [".md", ".markdown"] },
  },
];

export const supportsFileSystemAccess = () =>
  typeof window.showOpenFilePicker === "function" && typeof window.showSaveFilePicker === "function";

const isAbort = (error: unknown) => error instanceof DOMException && error.name === "AbortError";

/** Returns null when the user cancels the picker. */
export const pickMarkdownFile = async (): Promise<FileSystemFileHandle | null> => {
  try {
    const [handle] = await window.showOpenFilePicker!({ types: markdownPickerTypes });
    return handle ?? null;
  } catch (error) {
    if (isAbort(error)) return null;
    throw error;
  }
};

/** Returns null when the user cancels the picker. */
export const pickSaveLocation = async (suggestedName: string): Promise<FileSystemFileHandle | null> => {
  try {
    return await window.showSaveFilePicker!({ suggestedName, types: markdownPickerTypes });
  } catch (error) {
    if (isAbort(error)) return null;
    throw error;
  }
};

export const writeFile = async (handle: FileSystemFileHandle, content: string) => {
  if (handle.queryPermission && (await handle.queryPermission({ mode: "readwrite" })) !== "granted") {
    if (!handle.requestPermission || (await handle.requestPermission({ mode: "readwrite" })) !== "granted") {
      throw new Error("Write permission was denied");
    }
  }
  const writable = await handle.createWritable();
  await writable.write(content);
  await writable.close();
};
